import { Box, Grid2, Typography } from '@mui/material'
import { SummerCampImageCom } from '../../shared/components/SummerCamp/SummerCampImageCom'
import CustomDivider from '../../shared/utils/CustomDivider'
import Heading from '../../shared/utils/Heading'
import { Page_Padding } from '../../shared/constants'
import { getImageUrl } from '../../shared/utils/getImageUrl'

const GallerySection = ({ galleryCoverData, galleryData }) => {



  return (
    <Box >

      <Box

        px={Page_Padding}

        sx={{


          background: `linear-gradient(180deg, #EDF7FF 0%, #FFFFFF 100%)`,
        }}>
        <CustomDivider />
        <Heading Heading={galleryCoverData?.heading} center />
        <CustomDivider size={"1rem"} />
        <Grid2 container spacing={"1rem"}>
          {galleryCoverData?.memoryHeadingList?.map((item, index) => (
            <Grid2
              size={{ xs: 12, sm: 6, md: 4 }}
              children
              sx={{
                backgroundImage: `linear-gradient(180deg, rgba(0, 0, 0, 0) 0%, rgba(0, 0, 0, 0.6) 100%), url(${getImageUrl(item?.imageUrl)})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
                height: 500,
                borderRadius: '1rem',
                p: 2,
                display: "flex",
                alignItems: "flex-end",
                justifyContent: "center"

              }}
            >
              <Typography variant='h6' color='primary.main' dangerouslySetInnerHTML={{ __html: item?.listItemHeading }} />



            </Grid2>
          ))}
        </Grid2>

      </Box>
      <CustomDivider />

      {
        galleryData?.map((item, index) => (
          <Box key={index} px={Page_Padding}>

            <Box sx={{ textAlign: "center", width: "80%", mx: "auto" }}>
              <Typography variant='h6' color='red.main' dangerouslySetInnerHTML={{ __html: item?.year }} />






              <CustomDivider size={"1rem"} />
              <Typography variant='subtitle1' fontWeight={600} my={2} dangerouslySetInnerHTML={{ __html: item?.title }} />




              <CustomDivider size={"1rem"} />
              <Typography variant='body1' fontWeight={300} dangerouslySetInnerHTML={{ __html: item?.description }} />


              <CustomDivider size={"0.5rem"} />
              <Typography variant='subtitle1' fontWeight={600} dangerouslySetInnerHTML={{ __html: item?.focusTitle }} />

              <CustomDivider size={"0.5rem"} />
              {
                item?.focusPoints?.map((focusItem, index) => (
                  <Typography variant='body1' fontWeight={300} my={1} key={index} dangerouslySetInnerHTML={{ __html: focusItem }} />
                ))
              }
            </Box>
            <CustomDivider size={"2rem"} />
            <SummerCampImageCom itemData={item?.images} />
            <CustomDivider size={"2rem"} />
          </Box>
        ))
      }

    </Box>
  )
}

export default GallerySection
